export default __webpack_public_path__ + "static/media/typescript.48fea135.png";